module.exports = __webpack_public_path__ + "static/media/mapping-consumer-data-img-001.e91a1bcc.jpg";